import { useToastStore } from '@/stores/toastStore';

const DEFAULT_TIMEOUT_MS = 5_000;
const UNDO_TIMEOUT_MS = 10_000;

/**
 * Hook utilitaire pour pousser des toasts depuis n'importe quel composant.
 * Usage : const toast = useToast(); toast.success('RDV créé');
 */
export function useToast() {
  const push = useToastStore((s) => s.push);
  const dismiss = useToastStore((s) => s.dismiss);

  return {
    success(message: string, timeoutMs = DEFAULT_TIMEOUT_MS): string {
      return push({ type: 'success', message, expiresAt: Date.now() + timeoutMs });
    },
    error(message: string, timeoutMs = DEFAULT_TIMEOUT_MS): string {
      return push({ type: 'error', message, expiresAt: Date.now() + timeoutMs });
    },
    info(message: string, timeoutMs = DEFAULT_TIMEOUT_MS): string {
      return push({ type: 'info', message, expiresAt: Date.now() + timeoutMs });
    },
    withUndo(message: string, onUndo: () => void, undoLabel = 'Annuler'): string {
      return push({
        type: 'success',
        message,
        undoLabel,
        onUndo,
        expiresAt: Date.now() + UNDO_TIMEOUT_MS,
      });
    },
    dismiss,
  };
}
